export const joinDisclaimers = disclaimers => {
  if (!disclaimers) {
    return '';
  }
  return disclaimers
    .map(d => `<div class="notifications__section">${d}</div>`)
    .join('');
};
